// @flow strict

import * as React from 'react'
import { Link } from 'gatsby'
import { AccessibilityText } from '@mondough/public-web-components'

import styles from './Pagination.module.scss'

type PaginationProps = {
  numPages: number,
  currentPage: number,
  basePath: string,
}

const Pagination = ({
  currentPage,
  numPages,
  // The basePath can either be the root of the app, or a category/author page.
  // For example: /blog/ or /blog/product-updates/
  basePath = '',
}: PaginationProps) => {
  return (
    <section className={styles.container}>
      {/* eslint-disable-next-line jsx-a11y/heading-has-content */}
      <AccessibilityText as={<h2 />}>
        Navigate to the previous and next pages
      </AccessibilityText>
      {currentPage > 1 && (
        <Link
          className={styles.button}
          to={
            currentPage === 2
              ? basePath === ''
                ? '/'
                : basePath
              : `${basePath}/${currentPage - 1}`
          }
          aria-label="View the previous page of blog posts"
        >
          Previous
        </Link>
      )}
      <span
        className={styles.current}
      >{`Page ${currentPage} of ${numPages}`}</span>
      {currentPage < numPages && (
        <Link
          className={styles.button}
          to={`${basePath}/${currentPage + 1}`}
          aria-label="View the next page of blog posts"
        >
          Next
        </Link>
      )}
    </section>
  )
}

export default Pagination
